export default __webpack_public_path__ + "static/media/flexible-cms.5ff17026.png";